if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');
        this.internalChange = false;

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        if (this.internalChange) {
          this.internalChange = false;
          return;
        }

        const mediaId = event.detail.currentElement.dataset.mediaId;
        const cleanMediaId = mediaId?.replace(/^.*-/, '');
        const sectionId = this.dataset.sectionId || this.id.replace(/^MediaGallery-/, '');
        const mapElement = document.getElementById(`VariantMediaMap-${sectionId}`);

        if (!mapElement) return;
        const variantMediaMap = JSON.parse(mapElement.textContent || '{}');
        const variantId = variantMediaMap[cleanMediaId];
        if (!variantId) return;

        const productInfo = document.querySelector(`product-info[data-section="${sectionId}"]`);
        if (!productInfo) return;

        productInfo.renderProductInfo({
          requestUrl: `${productInfo.dataset.url}?variant=${variantId}&section_id=${sectionId}`,
          targetId: null,
          callback: productInfo.handleUpdateProductInfo(productInfo.dataset.url),
        });
      }

      setActiveMedia(mediaId, prepend) {
        this.internalChange = true;

        let activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);

        // Fallback si mediaId no existe y es "fallback"
        if (!activeMedia && mediaId === "fallback") {
          let fallback = this.elements.viewer.querySelector('[data-media-id="fallback"]');
          if (!fallback) {
            fallback = document.createElement('li');
            fallback.className = 'product__media-item grid__item slider__slide product__media-item--single media-gallery__fallback is-active';
            fallback.setAttribute('data-media-id', 'fallback');
            fallback.innerHTML = `
              <img src="${window.FALLBACK_IMAGE_URL}" alt="Imagen no disponible" style="max-width:100%;margin:auto;display:block;">
              <div style="text-align:center;color:#888;">Imagen Temporalmente NO disponible para esta Variante</div>
            `;
            const ul = this.elements.viewer.querySelector('ul');
            if (ul) ul.appendChild(fallback);
          }

          this.elements.viewer.querySelectorAll('[data-media-id]').forEach((el) => {
            el.classList.remove('is-active');
            el.style.display = 'none';
          });

          fallback.style.display = 'block';
          fallback.classList.add('is-active');
          return;
        } else {
          const fallback = this.elements.viewer.querySelector('[data-media-id="fallback"]');
          if (fallback) {
            fallback.classList.remove('is-active');
            fallback.style.display = 'none';
          }
        }

        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((el) => {
          el.classList.remove('is-active');
          el.style.display = 'none';
        });

        activeMedia.classList.add('is-active');
        activeMedia.style.display = 'block';

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const rect = activeMedia.getBoundingClientRect();
          if (rect.top > -0.5) return;
          window.scrollTo({ top: rect.top + window.scrollY, behavior: 'smooth' });
        });

        this.playActiveMedia(activeMedia);

        const thumbnail = this.elements.thumbnails?.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(thumbnail);
        this.announceLiveRegion(activeMedia, thumbnail?.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;
        this.elements.thumbnails.querySelectorAll('button').forEach((el) => el.removeAttribute('aria-current'));
        thumbnail.querySelector('button')?.setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia?.();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
